package com.solevo.dist.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.FirebaseUser
import dev.gitlive.firebase.auth.auth
import kotlinx.coroutines.delay
import kotlinx.coroutines.flow.first

@Composable
fun WaitForAuth(
    loadingContent: @Composable () -> Unit = { CenteredLoader() },
    content: @Composable (FirebaseUser) -> Unit
) {
    var user by remember { mutableStateOf<FirebaseUser?>(null) }
    var authReady by remember { mutableStateOf(false) }

    LaunchedEffect(Unit) {
        val authenticatedUser = Firebase.auth.authStateChanged.first { it != null }
        
        if (authenticatedUser != null) {
            val verifiedUser = Firebase.auth.currentUser
            if (verifiedUser != null) {
                verifiedUser.getIdToken(true)
//                delay(200)
                
                val finalUser = Firebase.auth.currentUser
                if (finalUser != null) {
                    user = finalUser
                    authReady = true
                }
            }
        }
    }

    val currentUser = user
    if (authReady && currentUser != null) {
        content(currentUser)
    } else {
        loadingContent()
    }
}

@Composable
fun <T> WaitForAuthAndViewModel(
    key: String,
    loadingContent: @Composable () -> Unit = { CenteredLoader() },
    viewModelFactory: (FirebaseUser) -> T,
    onViewModelReady: ((T) -> Unit)? = null,
    content: @Composable (T) -> Unit
) {
    WaitForAuth(loadingContent = loadingContent) { user ->
        val vm = remember(key, user.uid) { viewModelFactory(user) }
        
        if (onViewModelReady != null) {
            LaunchedEffect(key, user.uid) {
                onViewModelReady(vm)
            }
        }
        
        content(vm)
    }
}
